import { Switch } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import LocalizeInput from 'components/input/LocalizeInput';
import ModifyButtons from 'components/layouts/ModifyButtons';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useModelStateContext } from 'saladsoft-primitive';
import { AdminAmenityRequestDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';
import { AmenityModel } from 'types/CommonTypes';

const AmenityForm = ({
  onSave,
  amenity,
}: {
  onSave: (amenity?: AmenityModel) => void;
  amenity?: AmenityModel;
}) => {
  const { setState, stateModel } = useModelStateContext<AdminAmenityRequestDto>();
  const { uiStore } = useStoreWrapper();

  const handleClickSave = async () => {
    let result: any;
    if (amenity?.id) {
      result = await ServiceHelper.adminAmenityService?.updateAmenity(
        amenity?.id as number,
        stateModel as AdminAmenityRequestDto,
      );
    } else {
      result = await ServiceHelper.adminAmenityService?.createAmenity(
        stateModel as AdminAmenityRequestDto,
      );
    }

    if (result?.status && result.status < 300) {
      uiStore?.modal.close();
      toast.success('태그 추가 완료');
      onSave?.(result.data as AmenityModel);
    }
  };

  const handleClickDelete = () => {
    if (amenity?.id) {
      ServiceHelper.adminAmenityService?.deleteAmenity(amenity.id).then((res) => {
        if (res?.status && res.status < 300) {
          toast.success('태그 삭제 완료');
          onSave?.();
          uiStore?.modal.close();
        } else {
          toast.error('태그 삭제 실패');
        }
      });
    }
  };

  useEffect(() => {
    if (amenity) {
      setState('localizedName', amenity.localizedName);
    }
  }, [amenity]);

  return (
    <div>
      <LocalizeInput
        defaultValue={amenity?.localizedName}
        onChange={(value) => setState('localizedName', value)}
      />
      <FormControlLabel
        control={
          <Switch
            checked={stateModel?.isFilter}
            size="medium"
            onChange={(e) => {
              setState('isFilter', e.target.checked);
            }}
          />
        }
        label={'필터지정'}
      />
      <ModifyButtons
        showDelete={amenity?.id ? true : false}
        type={amenity?.id ? 'update' : 'create'}
        onCancel={() => uiStore?.modal.close()}
        onSave={() => {
          handleClickSave();
        }}
        onDelete={() => {
          handleClickDelete();
        }}
      />
    </div>
  );
};

export default AmenityForm;
